import { HttpStatusCode } from "types/types";

export interface UserApiErrorResponse {
  message?: string;
}

export type UserApiClientErrorParams = {
  errorResponse: UserApiErrorResponse[];
  status: HttpStatusCode;
  url?: string;
};

export class UserApiClientError extends Error {
  url: string;
  status: HttpStatusCode;
  errorResponse: UserApiErrorResponse[];

  constructor({ errorResponse, status, url }: UserApiClientErrorParams) {
    super(JSON.stringify(errorResponse));
    this.name = "UserApiClientError";
    this.status = status;
    this.url = url;
    this.errorResponse = errorResponse;
  }
}
